import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { ICON_TYPE, IconModule } from "@spartacus/storefront";
import { GenInfoMessageComponent } from '../info-message/info-message.component';

@Component({
  selector: 'gen-offline-badge',
  templateUrl: './offline-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconModule, GenInfoMessageComponent],
})
export class GenOfflineBadgeComponent {
  @Input() internalCalculation: boolean = false;

  icon = ICON_TYPE.INFO;
  offlineMessage: string;
  tooltipMessage: string = 'Pricing is not currently available. Orders will be placed with MSRP pricing.';
  isServicePartsEnabled: boolean;

  constructor(protected winRef: WindowRef) {
    this.isServicePartsEnabled = JSON.parse(this.winRef.localStorage.getItem('isServicePartsEnabled'));
    if (this.isServicePartsEnabled) {
      this.tooltipMessage = 'Pricing is not currently available. Orders will be placed with MSRP/MSLP pricing.'
    }
  }
}
